/* eslint-disable @typescript-eslint/no-explicit-any */
import { Typography } from '@design-system/components/typography/typography';
import { Row } from '@design-system/components/grid/grid';
import { Modal } from '@design-system/components/modal/modal';
import {
  AlertButton,
  TextButton,
} from '@design-system/components/button/button';

import { DiscountsVM } from '../view-model/discounts.viewModel';
import { F0 } from '@client/new/helpers/types';

export const DeactivateModal = (
  p: Pick<DiscountsVM, 'deactivationMode'> & { onClose: F0; onConfirm: F0 },
) => (
  <Modal
    isOpen={p.deactivationMode.type !== 'not-started'}
    onClose={p.onClose}
    title="Deactivate discount?"
  >
    <Typography size="large" fontWeight="bold">
      Once deactivated, the discount will no longer be available and this action
      cannot be undone.
    </Typography>
    <Row justifyEnd gap="m">
      <TextButton onClick={p.onClose}>Cancel</TextButton>
      <AlertButton
        onClick={p.onConfirm}
        loading={p.deactivationMode.type === 'in-progress'}
      >
        {p.deactivationMode.type === 'in-progress'
          ? 'Deactivating'
          : 'Deactivate'}
      </AlertButton>
    </Row>
  </Modal>
);
